// The live sky behind an outdoor place whose own picture has its sky cut out: the farm's sky (farm/skyLayer.js),
// stars and shooting stars (farm/starLayer.js) and clouds, screen-fixed. Used by the street (street/StreetSky.js) and
// the yards (MainScene, BackyardScene and their visits). The horizon is the place's tree and roof line, so the sun
// and moon rise from and set behind it; `horizonY` and `panX` are read every frame, so a level change or a scroll is
// followed at once. A shooting star emits 'sky-meteor' on the scene (the paintings' hook, house parts' plan, part 3).
import { GAME_WIDTH, GAME_HEIGHT } from '../config.js';
import { cycleT, nightIndex } from './skyClock.mjs';
import { createSkyLayer, clockInput } from './skyLayer.js';
import { createStarLayer } from './starLayer.js';
import { createClouds } from './backdropFx.js';

export function attachOutdoorSky(scene, { horizonY, panX = () => 0, cloudRows }) {
  let dead = false;
  const parts = [
    createSkyLayer(scene),
    createStarLayer(scene, { onMeteor: () => scene.events.emit('sky-meteor') }),
    createClouds(scene, { rows: cloudRows }),
  ];
  const update = () => {
    if (dead) return;
    const ci = clockInput();
    const ctx = {
      t: cycleT(ci), now: ci.now, night: nightIndex(ci), horizonY: horizonY(),
      panX: panX(), viewW: GAME_WIDTH, viewH: GAME_HEIGHT, dtMs: scene.game.loop.delta,
    };
    for (const p of parts) p.update(ctx);
  };
  const destroy = () => {
    if (dead) return;
    dead = true;
    for (const p of parts.splice(0)) p.destroy();
  };
  scene.events.once('shutdown', destroy);
  update();
  return { update, destroy };
}
